<template>
  <div class="markdown" v-html="renderedContentWithIcons"></div>
</template>

<script setup lang="ts">
import type { Document } from '@contentful/rich-text-types'
import { useRichText } from '@/composables/useRichText'

interface Props {
  document: Document
  listVariant?: 'default' | 'recipe'
}

const props = defineProps<Props>()

const renderedContent = computed(() => {
  if (!props.document) return ''
  return useRichText(props.document, { listVariant: props.listVariant || 'default' })
})

// SVG for the double arrow right icon - extracted from IconDoubleArrowRight component
const doubleArrowRightSvg = `
  <svg width="24" height="24" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6">
    <g clip-path="url(#clip0_3821_94)">
      <mask id="mask0_3821_94" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="29">
        <path d="M30 0H0V29H30V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3821_94)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5793 14.5L0.741073 24.0102C0.503392 24.2379 0.31458 24.5087 0.185479 24.8072C0.0563779 25.1056 -0.0104692 25.4257 -0.011224 25.7492C-0.0119788 26.0727 0.0533737 26.3931 0.181081 26.6921C0.308788 26.9911 0.496334 27.2627 0.73295 27.4914C0.969566 27.7202 1.25059 27.9015 1.55989 28.0249C1.86919 28.1483 2.20066 28.2115 2.53528 28.2108C2.86991 28.21 3.20108 28.1454 3.5098 28.0206C3.81851 27.8958 4.09868 27.7133 4.33422 27.4835L15.2808 16.9015C16.8897 15.2881 16.6773 13.4478 15.2856 12.1024L4.33439 1.51624C3.85786 1.05562 3.21155 0.796854 2.53765 0.796875C1.86375 0.796896 1.21746 1.0557 0.740956 1.51635C0.264452 1.977 -0.0032326 2.60176 -0.00321063 3.2532C-0.00318865 3.90464 0.264538 4.52939 0.741073 4.99001L10.5793 14.5ZM14.3313 4.98972C13.8548 4.52913 13.5872 3.90444 13.5872 3.25306C13.5872 2.60169 13.8548 1.977 14.3313 1.51641C14.8078 1.05582 15.454 0.797059 16.1279 0.797059C16.8017 0.797059 17.4479 1.05582 17.9244 1.51641L28.8756 12.1025C30.2673 13.4479 30.4797 15.2883 28.8708 16.9017L17.9244 27.4835C17.4479 27.9441 16.8017 28.2029 16.1279 28.2029C15.454 28.2029 14.8078 27.9441 14.3313 27.4835C13.8548 27.0229 13.5872 26.3982 13.5872 25.7469C13.5872 25.0955 13.8548 24.4708 14.3313 24.0102L24.1695 14.5L14.3313 4.98972Z" fill="currentColor" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3821_94">
        <rect width="30" height="29" fill="white" />
      </clipPath>
    </defs>
  </svg>
`

const renderedContentWithIcons = computed(() => {
  if (!renderedContent.value) return ''

  // Replace the placeholder spans with the SVG icon
  return renderedContent.value.replace(
    /<span class="rich-text-link-icon"><\/span>/g,
    `<span class="inline-flex items-center w-4 h-4 ml-1">${doubleArrowRightSvg}</span>`,
  )
})
</script>
